import React, { useEffect, useState } from 'react'
import axios from '../../API/axios';
import toast from 'react-hot-toast';
import { Button, Modal } from 'react-bootstrap';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";


const ApplyjobAsCandidate = ({ jobId, isAppliedByYou, status }) => {
  const sessionId = localStorage.getItem("sessionId");
  const [loading, setLoading] = useState("");


  const [showAppliedModal, setShowAppliedModal] = useState(false);
  const handleShow = () => setShowAppliedModal(true);
  const handleCloseModal = () => setShowAppliedModal(false);


  // ...................................ApplyJob by Cnddt.......................................
  const [CheckCandidateApplied, setCheckCandidateApplied] = useState(isAppliedByYou);
  const ApplyJob = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`/JobAction/ApplyJobAsCnddt`, {
        sessionId: sessionId,
        jobId: jobId,
      });
      console.log("ApplyJob", response);
      toast.success(response.data.message);
      setCheckCandidateApplied(true);
    } catch (error) {
      console.error("Error applying for job:", error);
      toast.error(error.response?.data?.message || "An error occurred.");
    } finally {
      setLoading(false); // Stop loading
    }
  };

  // Unapply job by candidate
  const UnApplyJobCandidate = async () => {
    console.log("unapply candidate clicked");

    setLoading(true); // Start loading
    try {
      const response = await axios.post(`/JobAction/UnApplyJobAsCnddt`, {
        sessionId: sessionId,
        jobId: jobId,
      });
      console.log("UnApplyJob", response);
      toast.success(response.data.message);
      setCheckCandidateApplied(false); // Mark as unapplied
      setShowAppliedModal(false);
    } catch (error) {
      console.error("Error applying for job:", error);
      toast.error(error.response?.data?.message || "An error occurred.");
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    setCheckCandidateApplied(isAppliedByYou)
  }, [isAppliedByYou])

  console.log("CheckCandidateApplied", CheckCandidateApplied);

  // ...............................................................................................................

  return (
    <>
    {status === 1 ? (
      <>
       {CheckCandidateApplied === true ? (
        <div className="appliedbtn mb-1">
          <Button
            className="InsApplybtn mainBtn  appliedBtn apply-job"
            style={{ width: "100px" }}
            onClick={() => {
              // UnApplyJobCandidate();
              handleShow();
            }}
          >
            <span className="default-text">Applied</span>
            <span className="hover-text">Withdraw</span>
          </Button>
        </div>
      ) : (
        <Button className="mainBtn apply-job" onClick={ApplyJob}>
          Apply Now
        </Button>
      )
      }
      </>
    ): 
    (
      <Button className="mainBtn red">
          Job Is InActive
        </Button>
    )
    }
     

      <Modal show={showAppliedModal} onHide={handleCloseModal} centered>
        <Modal.Header>
          <Modal.Title> UnApply job</Modal.Title>
          <CloseSharpIcon className="pointer" onClick={handleCloseModal} />
        </Modal.Header>
        <Modal.Body className="settings">
          <div className=" mb-3">
            <p>Are you sure you want to Unapply job</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={
              UnApplyJobCandidate
            }
            className="btn btn-danger me-2"
          >
            Confirm
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default ApplyjobAsCandidate